import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { getAudienceUsersAdminList } from '~/services/PromoService';

import { audienceUserQueryKeys } from './audienceQueryKeys';

type Params = {
  query: Parameters<typeof getAudienceUsersAdminList>[0];
  enabled?: boolean;
};

export function useListAudienceUsers({ query, enabled = true }: Params) {
  return useQuery({
    queryKey: audienceUserQueryKeys.list(query),
    queryFn: async ({ signal }) => getAudienceUsersAdminList(query, { signal }),
    enabled,
    placeholderData: keepPreviousData,
  });
}
